<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="course.course_name + ' [Training Course] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/training-courses`">
                            <i class="fa fa-graduation-cap"></i> Training Courses
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        {{ course.course_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Training Course</strong>
                            <div class="pull-right" v-if="this.$root.hasPermission(['training_courses.manage'])">
                                <router-link :to="`/training-courses/edit/${course.id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <b-dropdown right text="Distribute" variant="light" size="sm">
                                    <b-dropdown-item :to="`/training-courses/distribute/email?training_course_id=${course.id}`"><i class="fa fa-envelope"></i> Email</b-dropdown-item>
                                    <b-dropdown-item :to="`/training-courses/distribute/text?training_course_id=${course.id}`"><i class="fa fa-comment"></i> Text</b-dropdown-item>
                                </b-dropdown>
                                <router-link :to="`/training-courses/set-bulk-expiration/${course.id}`" class="btn btn-sm btn-light" v-if="course.valid_days">
                                    <i class="fa fa-bullseye"></i> Set Bulk Expiration
                                </router-link>
                                <router-link :to="`/training-courses/delete/${course.id}`" class="btn btn-sm btn-light">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Course Name:</div>
                                <div class="col-md-8">
                                    {{ course.course_name }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Completed Course Days Valid: <i class="fa fa-question-circle" title="This is the number of days a completed is course is valid. This value is used to calculated the suggested Expiration Date when entering completed courses, as well as auto-setting expiration dates in bulk for completed courses."></i></div>
                                <div class="col-md-8">
                                    <template v-if="course.valid_days">{{ course.valid_days }} Days</template>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Enable Public Access:</div>
                                <div class="col-md-8">
                                  <label class="badge badge-success" v-if="course.enable_public_access == 1">Yes</label>
                                  <label class="badge badge-default" v-else>No</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Enable Anonymous Access:</div>
                                <div class="col-md-8">
                                  <label class="badge badge-success" v-if="course.enable_anonymous_access == 1">Yes</label>
                                  <label class="badge badge-default" v-else>No</label>
                                </div>
                            </div>
                            <template  v-if="course.course_key && course.enable_public_access == 1">
                                <div class="row mb-2">
                                    <div class="col-md-4 text-md-right text-muted">Require Signature: <i class="fa fa-question-circle" title="This will require the employee or guest to sign upon completing the course."></i></div>
                                    <div class="col-md-8">
                                      <label class="badge badge-success" v-if="course.require_signature == 1">Yes</label>
                                      <label class="badge badge-default" v-else>No</label>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-4 text-md-right text-muted">Require Jobsite: <i class="fa fa-question-circle" title="This will require the employee or guest to select a Jobsite upon completing the course."></i></div>
                                    <div class="col-md-8">
                                      <label class="badge badge-success" v-if="course.require_jobsite == 1">Yes</label>
                                      <label class="badge badge-default" v-else>No</label>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-4 text-md-right text-muted">Public URL:</div>
                                    <div class="col-md-8">
                                        <a :href="publicUrl" target="_blank">
                                            {{ publicUrl }}
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Catalogs:</div>
                                <div class="col-md-8">
                                    <ul v-if="course.catalogs.length > 0" class="list-unstyled">
                                        <li v-for="catalog in course.catalogs">
                                            <router-link :to="`/training-courses/catalogs/view/${catalog.id}`">{{ catalog.catalog_name }}</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-md-right text-muted">Certificate Template:</div>
                                <div class="col-md-8">
                                    <a :href="`/files/download/${course.certificate_template_id}`" v-if="course.certificate_template_id">{{ course.certificate_template_name }}</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Course Details</strong>
                        </div>
                        <div class="card-body">
                            <div class="mb-2" v-html="course.course_details"></div>
                        </div>
                    </div>

                    <div class="card mb-4" v-if="course.enable_public_access == 1 && course.course_video_id">
                        <div class="card-header">
                            <strong>Training Course Video: {{ course.video.file_name }}</strong>
                        </div>
                        <div class="card-body">
                            <b-embed type="video" controls :src="`${video_url}`"></b-embed>
                        </div>
                    </div>

                    <div class="card mb-4" v-if="course.enable_public_access == 1 && course.completed_msg">
                        <div class="card-header">
                            <strong>Completed Message</strong>
                        </div>
                        <div class="card-body">
                            <div class="mb-2" v-html="course.completed_msg"></div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <i class="fa fa-group"></i> Employees <router-link :to="`/training-courses/course/${course.id}/add-employees`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> Add Employee</router-link>
                        </div>
                        <div class="card-body">
                            <employee-training-list :trainingCourseId="parseInt(id)" :courseType="'All'" :showDistributeButton="true" />
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">
                    <div class="card mb-4" v-if="course.enable_public_access">
                        <div class="card-header">QR Code <i class="fa fa-question-circle" title="Use this to create a scannable barcode that links back to this training course. This can be printed and displayed where easily accessible."></i></div>
                        <div class="card-body" style="overflow-x: auto;">
                            <div class="row">
                                <div class="col-xl-12 col-sm-6 col-xs-12">
                                    <b-input-group class="mb-2">
                                        <template #prepend>
                                            <b-input-group-text class="bg-light">Size</b-input-group-text>
                                        </template>
                                        <b-form-select v-model="qr_code_size" :options="qrCodeOptions"></b-form-select>
                                    </b-input-group>
                                    <div class="form-group">
                                        <b-form-select v-model="jobsite_id" :options="jobsiteOptions" />
                                    </div>

                                    <span v-show="qr_loading"><i class="fa fa-spin fa-spinner"></i></span>

                                    <div v-show="!qr_loading">
                                        <img :src="`data:image/png;base64,${qr_code_html}`" />
                                    </div>

                                    <div class="mt-2">
                                        <a :href="downloadQrCode" target="_blank">Download QR Code</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-files"></i> Files ({{ files.length }})
                        </div>
                        <div class="card-body">
                            <ul class="list-unstyled">
                                <li v-for="file in files" style="margin-bottom: 10px;">
                                    <a :href="`/files/${(file.download_only ? 'download' : 'view')}/${file.file_id}`" target="_blank">
                                        {{ file.file_name }}
                                    </a><br/>
                                    <div class="text-muted small">{{ file.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}, {{ file.FirstName }} {{ file.LastName }}</div>

                                    <template v-if="course.certificate_template_id == file.file_id">
                                        <label class="badge badge-info">Certificate Template</label>
                                    </template>
                                    <template v-else-if="course.course_video_id == file.file_id">
                                        <label class="badge badge-info">Course Video</label>
                                    </template>
                                    <template v-else>
                                        <a href="javascript:void(0)" class="text-danger ml-1" v-on:click="deleteFile(file)"><i class="fa fa-trash"></i> Delete</a>
                                    </template>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                qr_loading: false,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                jobsite_id: null,
                course: {},
                files: [],
                jobsites: [],
                video_url: null,
                qr_code_size: 5,
                qr_code_html: null,
                qrCodeOptions: [
                    {value: 3, text: '87x87'},
                    {value: 4, text: '116x116'},
                    {value: 5, text: '145x145'},
                    {value: 6, text: '174x174'},
                    {value: 7, text: '203x203'},
                    {value: 8, text: '232x232'},
                    {value: 9, text: '261x261'},
                ],
            }
        },

        watch: {
            qr_code_size(newVal, oldVal){
                //Get the QR Code
                this.getQrCode();
            },

            jobsite_id(newVal, oldVal){
                //Get the QR Code
                this.getQrCode();
            },
        },

        computed: {
            jobsiteOptions(){
                //Setup options
                var options = [
                    {value: null, text: '-- No Jobsite --'},
                ];

                //Loop through and build lists
                for(var i = 0; i < this.jobsites.length; i++)
                {
                    //Push onto options
                    options.push({value: this.jobsites[i].JobsiteId, text: (this.jobsites[i].JobsiteNumber ? this.jobsites[i].JobsiteNumber+' - ' : '') + this.jobsites[i].JobsiteName});
                }

                //Send it
                return options;
            },

            downloadQrCode(){
                //SEtup
                var url = '/training-courses/qr-code/'+this.course.id+'?download=true&qr_code_size='+this.qr_code_size;

                //Check for jobsite
                if(this.jobsite_id)
                {
                    url += '&jobsite_id='+this.jobsite_id;
                }

                //Send it
                return url;
            },

            publicUrl(){
                //Setup
                var url = this.$root.appUrl + '/training-courses/key/' + this.course.course_key;

                //Check for Jobsite
                if(this.jobsite_id)
                {
                    url += '?jobsite='+this.jobsite_id;
                }

                return url;
            },
        },

        methods: {

            getTrainingCourse() {
                //Get the data
                this.$http
                    .get('/training-courses/view/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.course = response.data.course;
                        this.files = response.data.files;
                        this.video_url = response.data.videoUrl;

                        //Set loading
                        this.loading = false;

                        //Get the QR Code
                        if(this.course.enable_public_access)
                        {
                            this.getQrCode();
                        }
                    })
                    .catch(response => {

                    });
            },

            getQrCode(){
                //QR Code
                this.qr_loading = true;

                //Setup
                var payload = {
                    jobsite_id: this.jobsite_id,
                    qr_code_size: this.qr_code_size,
                    load_jobsites: (this.jobsites.length == 0 ? true : false)
                };

                //Get the data
                this.$http
                    .get('training-courses/qr-code/' + this.course.id, payload)
                    .then(response => {
                        //Set all the data
                        this.qr_code_html = response.data.qr_code;
                        this.course.course_key = response.data.course_key;

                        //Check it
                        if(payload.load_jobsites)
                        {
                            this.jobsites = response.data.jobsites;
                        }
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.qr_loading = false;
                    });
            },
        },

        mounted() {
            //Get the Training Course
            this.getTrainingCourse();
        }
    }
</script>
